module.exports = __webpack_public_path__ + "img/point-1.ed69df95.png";